import {
    SHOW_ESCAPE_HATCH,
    HIDE_ESCAPE_HATCH
} from './EscapeHatchConstants';

export const showEscapeHatch = () => ({
    type: SHOW_ESCAPE_HATCH
});

export const hideEscapeHatch = () => ({
    type: HIDE_ESCAPE_HATCH
});
